/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CommunityPage = lazyLoad(
  () => import('./index'),
  module => module.CommunityPage,
);
